import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';

@Component({
  selector: 'app-workshop-jobcard-messaging-preview',
  templateUrl: './workshop-jobcard-messaging-preview.component.html',
  styleUrls: ['./workshop-jobcard-messaging-preview.component.scss']
})
export class WorkshopJobcardMessagingPreviewComponent {
  @Input() messages: any[] = [];
  @Input() unreadCount: number = 0;
  @Input() jobcard: any = {};

  countryData: any = this.helpersService.getCountryData();

  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService
  ) { }

  getSortedMessages() {
    return this.messages.sort((a, b) =>
      new Date(b.CreatedDate).getTime() - new Date(a.CreatedDate).getTime()
    );
  }

  shouldShowDateSeparator(message: any, index: number): boolean {
    if (index === 0) return true;

    const sortedMessages = this.getSortedMessages();
    const currentDate = new Date(message.CreatedDate).toDateString();
    const previousDate = new Date(sortedMessages[index - 1].CreatedDate).toDateString();

    return currentDate !== previousDate;
  }

  getDateDisplayText(dateString: string): string {
    const messageDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (messageDate.toDateString() === today.toDateString()) {
      return this.translate.instant('bikeshop.workshop.jobcard.manage.messaging.today');
    } else if (messageDate.toDateString() === yesterday.toDateString()) {
      return this.translate.instant('bikeshop.workshop.jobcard.manage.messaging.yesterday');
    } else {
      return this.translate.instant('bikeshop.workshop.jobcard.manage.messaging.older');
    }
  }

  truncateMessage(message: string, maxLength: number = 150): string {
    if (message.length <= maxLength) return message;
    return message.substring(0, maxLength) + '...';
  }

  getMessageTypeLabel(type: string): string {
    switch (type?.toLowerCase()) {
      case 'whatsapp':
        return 'WhatsApp';
      case 'sms':
        return 'SMS';
      default:
        return 'Message';
    }
  }

}
